import React from 'react';

interface PlusIconProps {
  className?: string;
  size?: number;
}

const PlusIcon: React.FC<PlusIconProps> = ({ className = '', size = 20 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M10 3.125V16.875M3.125 10H16.875" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusIcon;

